// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--ov5Kw";
export var footerLink = "footer-module--footerLink--lu22a";
export var linksContainer = "footer-module--linksContainer--5Tvtn";
export var subscribe = "footer-module--subscribe--qUjRE";